import type { TFunction } from 'i18next'
import { createErrorMapRule } from '../utils/create-rule.ts'

type TooSmallRuleVariation = 'more-info'

export const tooSmallRule = (
  t: TFunction<'validation'>,
  context?: Record<string, unknown>,
  variation?: TooSmallRuleVariation
) =>
  createErrorMapRule('too_small', t, (issue, _) => {
    if (issue.type === 'string' && variation) {
      return {
        message: t(`string.${variation}.min`, {
          ...issue,
          ...context,
          context: issue.inclusive ? 'inclusive' : 'exclusive',
          count: Number(issue.minimum),
        }),
      }
    }

    return {
      message: t(`${issue.type}.min`, {
        ...issue,
        ...context,
        context: issue.inclusive ? 'inclusive' : 'exclusive',
        count: Number(issue.minimum),
      }),
    }
  })
